<!-- 进场上报接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructureForThirdPark"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KKN885S",
                "carLicenseNumber": "渝BSF029",
                "confidence": 95,
                "correctConfidence": 0,
                "correctType": 0,
                "enterCarCardNumber": "",
                "enterCarColor": 0,
                "enterCarLicenseColor": 1,
                "enterCarLicenseNumber": "渝BSF028",
                "enterCarLicenseType": 0,
                "enterCarLogo": 0,
                "enterCarType": 1,
                "enterChannelCode": "2881009",
                "enterChannelName": "7栋左入口",
                "enterChargeGroupCode": "1",
                "enterCustomVipName": "",
                "enterNovipCode": 1,
                "enterRecognitionConfidence": 95,
                "enterSpeed": 0,
                "enterStatisticalArea": "0",
                "enterTime": "20190704120000",
                "addTime": "20190704120000",
                "enterType": 1,
                "enterVipRule": "",
                "enterVipType": 1,
                "extendInfo": {
                    "enterNoVipCodeName": "正常",
                    "inEtcCarCode": "",
                    "inEtcCode": "",
                    "inEtcReliable": "0",
                    "selfInCode": "",
                    "selfInUserUniqCode": ""
                },
                "inDriverPosPicId": "",
                "inOperatorName": "wdl",
                "inOperatorTime": "20190704120000",
                "isCorrect": 0,
                "lastCorrectLicenseNumber": "",
                "lastCorrectName": "",
                "recordType": 1,
                "remark": ""
            },
            responseCode: {
                "data": {
                    "parkingCode": "2017092909505802078030",
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统主动推送车辆进场信息到智慧停车开放平台",
                sdkcondition: "cmd='upThirdParkCarIn'",
                t_url: this.commonUrls.test + "upThirdParkCarIn",
                p_url: this.commonUrls.prod + "upThirdParkCarIn",
                precondition: "联系智慧停车管理员创建第三方车场",
                fitSystem: "第三方停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'carLicenseNumber', info2: '是', info3: 'String', info4: '最终车牌号' },
                        { info1: 'confidence', info2: '是', info3: 'Decimal', info4: '最终识别置信度。0-100' },
                        { info1: 'correctConfidence', info2: '是', info3: 'Decimal', info4: '校正置信度。0-100' },
                        { info1: 'correctType', info2: '是', info3: 'Integer', info4: '校正类型	0未校正，1手动校正，2自动校正，后续详见校正表' },
                        { info1: 'enterCarLicenseNumber', info2: '是', info3: 'String', info4: '进场时识别车牌号' },
                        { info1: 'enterCarCardNumber', info2: '否', info3: 'String', info4: '进场卡号' },
                        { info1: 'enterTime', info2: '是', info3: 'String', info4: '进场时间。yyyyMMddHHmmss' },
                        { info1: 'enterChannelName', info2: '是', info3: 'String', info4: '进进场通道名' },
                        { info1: 'enterChannelCode', info2: '是', info3: 'String', info4: '进场通道编号' },
                        { info1: 'enterVipType', info2: '否', info3: 'Integer', info4: '进场Vip类型	（<url>参考附录:/Api/appendixData</url>）' },
                        { info1: 'enterType', info2: '是', info3: 'Integer', info4: '进场类型：<url>参考附录:/Api/appendixData</url>' },
                        { info1: 'enterSpeed', info2: '否', info3: 'Decimal', info4: '进场速度' },
                        { info1: 'enterCarLicenseColor', info2: '是', info3: 'Integer', info4: '进场车牌颜色' },
                        { info1: 'enterCarColor', info2: '是', info3: 'Integer', info4: '进场车辆颜色' },
                        { info1: 'enterCarLogo', info2: '是', info3: 'Integer', info4: '进场车标' },
                        { info1: 'enterCarLicenseType', info2: '是', info3: 'Integer', info4: '进场车牌类型' },
                        { info1: 'enterCarType', info2: '是', info3: 'Integer', info4: '车辆类型 0未知 1小车 2大车 3超大车 4中型车' },
                        { info1: 'enterRecognitionConfidence', info2: '是', info3: 'Decimal', info4: '进场识别置信度。0-100' },
                        { info1: 'recordType', info2: '是', info3: 'Integer', info4: '记录类型	0未定义，1有牌车，2无牌车，3遮挡车，4非汽车，5误触发' },
                        { info1: 'isCorrect', info2: '是', info3: 'Integer', info4: '是否校正 车牌是否被纠正（0未纠正，1已纠正）' },
                        { info1: 'lastCorrectLicenseNumber', info2: '否', info3: 'String', info4: '最后校正校正车牌' },
                        { info1: 'lastCorrectName', info2: '否', info3: 'String', info4: '最后校正人名' },
                        { info1: 'lastCorrectTime', info2: '否', info3: 'String', info4: '最后校正时间。yyyyMMddHHmmss' },
                        { info1: 'remark', info2: '否', info3: 'String', info4: '备注' },
                        { info1: 'addTime', info2: '是', info3: 'String', info4: '记录添加时间。yyyyMMddHHmmss' },
                        { info1: 'inOperatorName', info2: '是', info3: 'String', info4: '放入操作员名' },
                        { info1: 'inOperatorTime', info2: '是', info3: 'String', info4: '放入操作时间' },
                        { info1: 'enterCustomVipName', info2: '否', info3: 'String', info4: '进场用户自定义VIP名称' },
                        { info1: 'enterStatisticalArea', info2: '否', info3: 'String', info4: '进场统计区域	中括号包裹区域序号逗号分个，如[1],[5]' },
                        { info1: 'enterNovipCode', info2: '是', info3: 'Integer', info4: '进场非VIP类型码	0未知，1正常，2VIP转临时车，3没有通道权限' },
                        { info1: 'enterVipRule', info2: '否', info3: 'String', info4: '进场VIP类型编号' },
                        { info1: 'enterChargeGroupCode', info2: '否', info3: 'String', info4: '进场计费规则编号' },
                        { info1: 'inDriverPosPicId', info2: '否', info3: 'String', info4: '进场驾驶位抓拍图片id' },
                        { info1: 'extendInfo', info2: '是', info3: 'JsonObject', info4: '备注' },
                        { info1: 'remark', info2: '是', info3: 'String', info4: '扩展信息' },
                        ]
                },{
                    titleName: 'extendInfo',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'selfInCode', info2: '是', info3: 'String', info4: '自助进场随机码' },
                        { info1: 'selfInUserUniqCode', info2: '是', info3: 'String', info4: '自助进场用户标识' },
                        { info1: 'inEtcCarCode', info2: '否', info3: 'String', info4: '进场ETC卡号' },
                        { info1: 'inEtcCode', info2: '否', info3: 'String', info4: '进场ETC车牌号' },
                        { info1: 'inEtcReliable', info2: '是', info3: 'String', info4: '进场ETC是否可信（0否，1是）。非ETC请设置为0' },
                        { info1: 'enterNoVipCodeName', info2: '否', info3: 'String', info4: '进场非VIP类型名称' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '智慧停车账单编号' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/thirdParkForAke/upward/upThirdParkCarIn.vue